import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject, Subject, catchError, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StorageService } from '../utils/storage/storage.service';

@Injectable({
    providedIn: 'root'
})
export class PermissionsService {
    private userPermissions: string[] = [];
    private userPermissions$: ReplaySubject<any> = new ReplaySubject<any>();
    private isUserAdmin: boolean = false;

    private basePath = environment.interop.basePath;
    private getUserPermissionsAuthLibUrl = this.basePath + environment.interop.clients.permissions.getUserPermissionsAuthLib;

    private clientId = environment.interop.clientId;
    private moduleId = environment.interop.moduleId;

    constructor(private http: HttpClient, private storageService: StorageService) { }

    private fetchUserPermissions(clientId: number, moduleId: number) {
        return this.http
            .get(this.getUserPermissionsAuthLibUrl + clientId + '/' + moduleId)
            .pipe(
                // tap((data) => console.log(data)),
                map(
                    (response: any) =>
                        (Object.values(response.data)[0] as any).permissions
                )
            );
    }

    storeUserPermissions() {
        return this.fetchUserPermissions(this.clientId, this.moduleId)
            .subscribe({
                next: (data: any) => {
                    this.userPermissions = data;
                    this.userPermissions$.next(true);
                },
                error: (err: any) => {
                    console.log(err);
                },
            });
    }

    getUserPermissions() {
        return this.userPermissions;
    }

    getUserPermissions$() {
        return this.userPermissions$;
    }

    checkUserAdmin(): any {
        var self = this;
        const userObj = self.storageService.getObject(environment.config.userKey);
        userObj
            .then((val) => {
                this.isUserAdmin = val.user_type_id == 2 ? true : false;
                //return (val.user_type_id == 2 ? true : false)
            })
            .catch((err) => {
                console.log(err, 'error on storage read');
                // return false;
            });
    }

    hasPermission(targetPermission: string): boolean {
        if (this.isUserAdmin) {
            return true;
        }
        return this.userPermissions.some((permission) =>
            permission === targetPermission
        );
    }

    resetUserPermissions() {
        this.isUserAdmin = false;
        this.userPermissions = [];
        this.userPermissions$ = new ReplaySubject<any>();
    }
}
